// ##############################
// // // artists
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const artists = [
    {avatar: IMGDIR+"/images/music/artists/artist-1.jpg", name: "Fiona Vance", position: "Rock Band", age: "42"},
    {avatar: IMGDIR+"/images/music/artists/artist-3.jpg", name: "Grace Turner", position: "Fairy Night", age: "26"},
    {avatar: IMGDIR+"/images/music/artists/artist-4.jpg", name: "Irene Smith", position: "Zapper", age: "31"},
    {avatar: IMGDIR+"/images/music/artists/artist-7.jpg", name: "Julia Vasar", position: "Ring n Roll", age: "32"},
    {avatar: IMGDIR+"/images/music/artists/artist-6.jpg", name: "Evan Short", position: "Zing ring", age: "37"},
    {avatar: IMGDIR+"/images/music/artists/artist-8.jpg", name: "Lily White", position: "Tempo tunes", age: "33"},
    {avatar: IMGDIR+"/images/music/artists/artist-11.jpg", name: "Leah Young", position: "Zohra", age: "25"},
    {avatar: IMGDIR+"/images/music/artists/artist-9.jpg", name: "Colin Taylor", position: "Jashan", age: "35"},
]; 

export {
    artists, 
};
